import React from "react";
import { Alert, Avatar, Button, Col, Divider, Row, Upload } from "antd";
import TextArea from "antd/es/input/TextArea";
import { UploadOutlined } from "@ant-design/icons";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

const ConfirmNotice = ({ itemId, listId, checkedItems }) => {
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  return (
    <div>
      <Row>
        <Col span={24}>
          <Row gutter={[0, 16]}>
            <Col span={24}>
              <Alert
                message=" Tenants Breaking Lease- the only time we waive the lease break
        fee are as follows."
                type="info"
                style={{ marginBottom: "10px" }}
              />
            </Col>
            <Col span={24}>
              <Alert
                message="-approval from the broker"
                type="info"
                style={{ marginBottom: "10px" }}
              />
            </Col>
            <Col span={24}>
              <Alert
                message="-tenant is relocating due to military orders. this is only
                applicable to military orders and not job relocation. we will
                NOT waive lese break fee for moving due to a normal job."
                type="info"
                style={{ marginBottom: "10px" }}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24} style={{ marginTop: "20px" }}>
          <Row gutter={[0, 16]}>
            <Col span={24}>
              <Alert
                message="go to tenant page in appfolio and email this message"
                type="success"
                style={{ textAlign: "center", marginBottom: "10px" }}
              />
            </Col>
            <Col span={24}>
              <Alert
                message="I'm writing to let you know that your notice to vacate has been
                received and is currently under review. This is a standard
                procedure to ensure your notice was within the range as outlined
                in your lease. We will let you know once your notice to vacate
                has been approved and what the next steps are in the move-out
                process. Please reply back if you have any questions."
                type="success"
                style={{ textAlign: "left", marginBottom: "10px" }}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="end" gutter={[8, 0]}>
            <Col>
              <Button>Skip</Button>
            </Col>
            <Col>
              <Button
                type="primary"
                onClick={handleComplete}
                disabled={isItemChecked}
              >
                Complete
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Divider />

      <Row>
        <Col span={2}>
          <Avatar>KA</Avatar>
        </Col>
        <Col span={22}>
          <TextArea
            style={{
              height: 200,
              resize: "none",
            }}
            placeholder="Write a comment… Type @ to mention other users."
          />
        </Col>
      </Row>
      <Row justify="end" gutter={16}>
        <Col>
          <Upload>
            <Button style={{ marginTop: "10px" }}>
              <UploadOutlined />
            </Button>
          </Upload>
        </Col>
        <Col>
          <Button style={{ marginTop: "10px" }}>Send</Button>
        </Col>{" "}
      </Row>
    </div>
  );
};

export default ConfirmNotice;
